import React from 'react';

const backDrop = (props) => {
    return (
        <div className="overlay" style={(props.show ? { display: "block" } : { display: "none" })} onClick={props.clicked}></div>
    );
}

export default backDrop;